.ValueSetTable {
  border-collapse: separate;
  max-width: 780px;
}
td.value :global(.TextProperty) p:last-child {
  margin-bottom: 0;
}
